import { styled, media } from '@nx-kit/styling';
import { DatePicker } from 'components/molecules/DatePicker';
import { BgMotivStyled } from 'components/atoms/PageBackground/PageBackground';
import Column from 'components/layout/Grid/Column';
import { Heading } from 'components/atoms/Heading';
import { SortGroupStyled } from 'components/molecules/FilterRows';

export const HeadingStyled = styled(Heading)`
  margin-bottom: 12px;
`;

export const DateStyled = styled.div`
  color: ${({ theme }) => theme.global.color.primary};
  font-weight: 400;
  line-height: 42px;
  font-size: 32px;

  ${media('md')} {
    font-size: 32px;
    line-height: 42px;
  }

  ${media('lg')} {
    font-size: 46px;
    line-height: 56px;
  }
`;

export const BgMotivTagesplanStyled = styled(BgMotivStyled)`
  img {
    top: -60px;
  }
  display: none;

  ${media('md')} {
    display: block;
  }
`;

export const RowDateSelectStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 30px;
  width: 100%;

  ${media('md')} {
    flex-direction: row;
    align-items: center;
  }
`;

export const RowDownloadStyled = styled.div`
  margin: 30px 0 90px;
`;

export const RowLoadingStyled = styled.div`
  margin: 30px 0;
`;

export const DatePickerStyled = styled(DatePicker)`
  margin-top: 10px;
  width: 100%;

  ${media('md')} {
    margin-left: 26px;
    margin-top: 0;
    width: auto;
  }
`;

export const ColumnStyled = styled(Column)`
  position: relative;
`;

export const SortGroup = styled(SortGroupStyled)`
  margin-top: 40px;
  margin-bottom: 0;
  ${media('md')} {
    margin-top: 0;
    margin-left: auto;
  }
`;
